import { render } from "./loginuser.vue?vue&type=template&id=6b4daa06"
import script from "./loginuser.vue?vue&type=script&lang=js"
export * from "./loginuser.vue?vue&type=script&lang=js"

import "./loginuser.vue?vue&type=style&index=0&id=6b4daa06&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__